import strings from 'strings';
import { SendoutStatus, SendoverStatus } from 'UI/constants/status';

import { DECLINATION_STATUS } from './DeclinationReasons.constants';

const { declinationReasons: STRINGS } = strings.sendoutsV2.drawers;

const NO_OFFER_STATUS_IDS = [SendoutStatus.NoOffer, SendoverStatus.NoOffer];
const DECLINED_STATUS_IDS = [SendoutStatus.Declined, SendoverStatus.Declined];

const DECLINATION_TITLE_BY_STATUS = {
  [DECLINATION_STATUS.NoOffer]: STRINGS.title.noOffer,
  [DECLINATION_STATUS.Declined]: STRINGS.title.declination
};

export const resolveDeclinationStatus = statusId => {
  if (NO_OFFER_STATUS_IDS.includes(statusId)) return DECLINATION_STATUS.NoOffer;
  if (DECLINED_STATUS_IDS.includes(statusId)) return DECLINATION_STATUS.Declined;
  return undefined;
};

export const getDeclinationCopyByStatus = status => ({
  title: DECLINATION_TITLE_BY_STATUS[status]
});
